<div class="w-full p-6">
    <div class="whiteCard p-4 lg:p-5">
        <div class="main-title-wrapper">
            <div class="left-side-content">
                <h2 class="title">{{ LABELS.INVENTORY}}</h2>
            </div>
            <div class="right-side-content">
                <div>
                    <button class="-ml-4 btn-theme-color !min-w-[90px]" mat-button type="button"
                        (click)="onRefreshTable()">Refresh</button>
                </div>
                <mat-form-field [subscriptSizing]="'dynamic'" class="fuse-mat-dense fuse-mat-rounded min-w-64">
                    <mat-icon [svgIcon]="'heroicons_solid:magnifying-glass'" class="icon-size-5" matPrefix></mat-icon>
                    <input [(ngModel)]="query.search" [autocomplete]="'off'" [placeholder]="LABELS.SEARCH"
                        (keyup)="applySearch($event)" matInput class="!pr-4" />
                    @if(query.search){
                    <span class="absolute top-1/2 -translate-y-1/2 right-2 h-5 w-5 cursor-pointer"
                        (click)="clearFilter()"><img class="w-full !h-full object-contain" src="error_icon.svg"
                            alt="error"></span>
                    }
                </mat-form-field>
            </div>

        </div>
        @if(inventoryDetails?.length > 0){
        <div class="w-full p-6 overflow-auto inventory-module" infiniteScroll [infiniteScrollDistance]="0.5"
            (scrolled)="onScroll()">
            @for(inventory of inventoryDetails; track inventory){
            <div class="whiteCard p-5 inventory-title-card mt-4 border border-[#dbdbdb]">
                <!-- <div class="icon-content-wrap justify-between">
                    <span class="material-icons">remove_red_eye</span>
                   
                </div> -->
                <div class="flex-box justify-between !items-start !mt-0">
                    <div class="flex gap-3 items-center">
                     <div class="w-15 h-15 overflow-hidden rounded-xl">
                        <img class="w-full h-full object-cover object-center cursor-pointer" (click)="_helper.openImage(inventory?.productImageUrl)" [src]="inventory?.productImageUrl" alt="product">
                    </div>
                    <div class="product-code-wrap flex flex-col">
                        <h2 class="main-title">{{inventory?.itemNameEn || '-'}}</h2>
                        <span>Product Code: {{inventory?.productCode|| '-'}}</span>
                        @if(inventory?.sku){
                        <span>SKU: {{inventory?.sku|| '-'}}</span>
                        }
                    </div>
                    </div>
                    @if(inventory?.noOfQuantity){
                    <div class="total-units text-right">
                        <h3 class="unit-title">{{inventory?.noOfQuantity}} units</h3>
                        <p class="text-grey">Accros all variants, colors and sizes</p>
                    </div>
                    } @else {
                    @if(inventory?.inventoryData?.length > 0){
                    <div class="total-units text-right">
                        <h3 class="unit-title-red">Out of stock</h3>
                    </div>
                    }
                    }
                </div>
                <div class="inventory-content-card product-management-module">
                    @if (inventory?.inventoryData?.length > 0) {
                    @for (variant of inventory.inventoryData; track variant) {

                    <p class="pt-5"><b>Variant : {{variant.variants?.variantName}}</b></p>

                    @for (color of variant.colorData; track color) {
                    <div class="color-card-box">
                        <!-- <div class="wrap-title">
                        <h2 class="main-title">{{ color?.colorName || '-' }}</h2>
                        <span class="blue-bg badge">{{ color?.colorQty || '-' }} units</span>
                    </div> -->
                        <div class="wrap-title">
                            <div class="product-image-with-color">
                                <div class="color-card">
                                    <div class="new-color-code-box" [class.!mt-0]="$index === 0">
                                        <span class="color-box block rounded-[10px]" [style.background]="color.color"
                                            (click)="setColor = color.color"
                                            [ngClass]="setColor == color.color ? 'active' : ''"></span>
                                    </div>
                                    <div class="wrap-color">
                                        <span class="color-text mb-0 font-semibold">
                                            {{color?.colorName ?
                                            color.colorName : '-'}}
                                        </span>
                                        <span class="color-text">{{color.color}}</span>
                                    </div>
                                </div>
                                <div class="slider-images">
                                    @if(color.itemImages && color.itemImages.length > 0){
                                    <app-custom-image-swiper [images]="getImage(color.itemImages)"
                                        [viewProduct]="true"></app-custom-image-swiper>
                                    }
                                </div>
                            </div>
                            <span class="blue-bg badge">{{ color?.colorQty ||
                                '-' }}
                                units</span>
                        </div>

                        <div class="size-card-box">
                            <ul>
                                <li>
                                    <span>Size</span>
                                    <span>Quantity</span>
                                    <span>Status</span>
                                </li>

                                @for (size of color?.stockBySize; track size) {
                                <li>
                                    <span>{{ size?.size || '-' }}</span>
                                    <span>{{ size?.stock || '00' }}</span>
                                    <span>
                                        <span class="badge" [ngClass]="
                            size?.stock == 0
                            ? 'red-bg'
                            : size?.stock < 5
                            ? 'yellow-bg'
                            : 'green-bg'
                        ">
                                            {{
                                            size?.stock == 0
                                            ? 'Out Of Stock'
                                            : size?.stock < 5 ? 'Low Stock' : 'In Stock' }} </span>
                                        </span>
                                </li>
                                }
                            </ul>
                        </div>
                    </div>
                    }
                    }
                    } @else {
                    <div class="color-card-box">
                        No Variant Added
                    </div>
                    <!-- </div> -->
                    }
                </div>

            </div>
            }
        </div>
        } @else{
        <div class="w-full p-6 overflow-auto inventory-module">
            <div class="whiteCard p-5 inventory-title-card mt-4">
                <div class="p-8 text-center text-3xl font-semibold tracking-tight sm:p-16 !font-[400]">
                    {{'No Data Found'}}
                </div>
            </div>
        </div>
        }
    </div>
</div>